import { render, staticRenderFns } from "./crowdfunding_upload.vue?vue&type=template&id=38fb134d&scoped=true"
import script from "./crowdfunding_upload.vue?vue&type=script&lang=js"
export * from "./crowdfunding_upload.vue?vue&type=script&lang=js"
import style0 from "./crowdfunding_upload.vue?vue&type=style&index=0&id=38fb134d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb134d",
  null
  
)

export default component.exports